// @material-ui core components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../components/MDBox";
import MDTypography from "../../../../components/MDTypography";

import { Avatar } from "@mui/material";

function BasicInfo() {
  const user_info = JSON.parse(sessionStorage.getItem("user"));
  const avatarSrc = user_info.foto
    ? typeof user_info.foto === "string"
      ? user_info.foto
      : URL.createObjectURL(user_info.foto)
    : undefined;

  const avatarLetter = user_info.first_name.charAt(0).toUpperCase();
  return (
    <Card id="basic-info" sx={{ overflow: "visible", marginTop: 13 }}>
      <MDBox pb={3} px={3}>
        <MDBox display="flex" justifyContent="space-between" mt={2}>
          <Avatar
            src={avatarSrc}
            sx={{ marginTop: "-100px", width: "135px", height: "135px" }}
          >
            {!avatarSrc && avatarLetter}
          </Avatar>
          <MDBox
            display="flex"
            flexDirection={"column"}
            alignItems={"flex-end"}
          >
            <MDTypography variant="h5" textTransform="uppercase">
              Información
            </MDTypography>
            <MDTypography variant="h5" textTransform="uppercase">
              Básica
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox mt={3}>
          <MDBox mb={2}>
            <MDTypography variant="button" fontWeight="bold">
              Nombre(s)
            </MDTypography>
            <MDTypography variant="body2" fontWeight="regular">
              {user_info.first_name}
            </MDTypography>
          </MDBox>
          <MDBox display="flex">
            <MDBox mb={2} width={"100%"}>
              <MDTypography variant="button" fontWeight="bold">
                Apellido Paterno
              </MDTypography>
              <MDTypography variant="body2" fontWeight="regular">
                {user_info.apellido_paterno}
              </MDTypography>
            </MDBox>

            <MDBox mb={2} width={"100%"}>
              <MDTypography variant="button" fontWeight="bold">
                Apellido Materno
              </MDTypography>
              <MDTypography variant="body2" fontWeight="regular">
                {user_info.apellido_materno}
              </MDTypography>
            </MDBox>
          </MDBox>
          <MDBox display="flex">
            <MDBox mb={2} width={"100%"}>
              <MDTypography variant="button" fontWeight="bold">
                Usuario
              </MDTypography>
              <MDTypography variant="body2" fontWeight="regular">
                {user_info.username.toUpperCase()}
              </MDTypography>
            </MDBox>

            <MDBox mb={2} width={"100%"}>
              <MDTypography variant="button" fontWeight="bold">
                Email
              </MDTypography>
              <MDTypography variant="body2" fontWeight="regular">
                {user_info.email}
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default BasicInfo;
